import * as http from '~/utils/apis';
export const API_PREFIX = 'cms-api/card-saga/adventures';
import { ResponseTransformer } from '../ResponseTransformer';
import { camelizeKeys } from '~/utils/helpers';

export const adventureCardApi = {
    getAll: async () => {
        const { data } = await http.get(`${API_PREFIX}`);
        return data;
    },

    create: async () => {
        const { data } = await http.get(`${API_PREFIX}/create`);

        const card = new ResponseTransformer(data);
        card.transformObjectKey();
        card.transformCategory();

        return card;
    },

    store: async (body) => {
        await http.post(`${API_PREFIX}`, body, {});
    },

    show: async (id) => {
        let { data } = await http.get(`${API_PREFIX}/${id}`);

        const card = new ResponseTransformer(data);
        card.transformObjectKey();
        card.transformCategory();
        card.transformKeyword();

        return card;
    },

    update: async (id, body) => {
        await http.put(`${API_PREFIX}/${id}`, body, {});
    },

    delete: async (id) => {
        await http.destroy(`${API_PREFIX}/${id}`);
    },
};

function transformCategory() {
    this.data.model.template = this.data.model.category.template;
    delete this.data.model.category;
}
function transformCategories() {
    this.data.categories.forEach(function (category, i, arr) {
        category.template = camelizeKeys(category.template);
        arr[i] = category;
    });
}
ResponseTransformer.prototype.transformCategory = transformCategory;
ResponseTransformer.prototype.transformCategories = transformCategories;
